var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { style: { height: "100%" }, attrs: { tag: "w-card" } },
    [
      _c(
        "w-card-title",
        [
          _c(
            "w-link",
            {
              staticClass: "hidden-md-up back-arrow",
              attrs: { to: _vm.basePath },
            },
            [_c("w-fa", { attrs: { icon: "arrow-left" } })],
            1
          ),
          _vm._v(" " + _vm._s(_vm.$ct("create-ticket")) + " "),
        ],
        1
      ),
      _c(
        "w-card-content",
        { style: { flexGrow: 1 } },
        [
          _c(
            "w-row",
            { style: { flexGrow: 1 } },
            [
              _vm.isFreeTier
                ? _c("w-col", { attrs: { xs: "12" } }, [
                    _c("div", { staticClass: "infobox" }, [
                      _vm._v(" " + _vm._s(_vm.$ct("free-no-service")) + " "),
                    ]),
                  ])
                : _vm.serviceExpired
                ? _c("w-col", { attrs: { xs: "12" } }, [
                    _c(
                      "div",
                      { staticClass: "infobox" },
                      [
                        _vm._v(" " + _vm._s(_vm.$ct("service-expired")) + " "),
                        _c(
                          "w-link",
                          { attrs: { to: "/account/service-pack" } },
                          [_vm._v(_vm._s(_vm.$ct("service-expired-activate")))]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.selectDossier
                ? _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          items: _vm.dossierItems,
                          label: _vm.$ct("dossier"),
                          "has-error": !_vm.selectedDossierId && _vm.validating,
                          fancy: "",
                          filter: "",
                        },
                        model: {
                          value: _vm.selectedDossierId,
                          callback: function ($$v) {
                            _vm.selectedDossierId = $$v
                          },
                          expression: "selectedDossierId",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    class: { error: !_vm.subject && _vm.validating },
                    attrs: {
                      label: _vm.$ct("subject"),
                      fancy: "",
                      required: "",
                      autofocus: "",
                    },
                    model: {
                      value: _vm.subject,
                      callback: function ($$v) {
                        _vm.subject = $$v
                      },
                      expression: "subject",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-select", {
                    attrs: {
                      value: _vm.priority,
                      items: _vm.priorities,
                      label: _vm.$ct("priority"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.priority,
                      callback: function ($$v) {
                        _vm.priority = $$v
                      },
                      expression: "priority",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-select", {
                    attrs: {
                      value: _vm.departement,
                      items: _vm.departements,
                      label: _vm.$ct("departement"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.departement,
                      callback: function ($$v) {
                        _vm.departement = $$v
                      },
                      expression: "departement",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-textarea-autogrow", {
                    class: { error: !_vm.content && _vm.validating },
                    attrs: {
                      label: _vm.$ct("content"),
                      fancy: "",
                      required: "",
                      "min-height": 400,
                    },
                    model: {
                      value: _vm.content,
                      callback: function ($$v) {
                        _vm.content = $$v
                      },
                      expression: "content",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-file-image-preview", {
                    attrs: { value: _vm.files },
                    on: {
                      remove: function ($event) {
                        return _vm.removeFile($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-file-upload", {
                    attrs: { label: _vm.$ct("attachements") },
                    on: {
                      input: function ($event) {
                        return _vm.onFile($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.create()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.create")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }